export const ACTIONS_TYPES = {
  ADD_FAVORITE: "ADD_FAVORITE",
  REMOVE_FAVORITE: "REMOVE_FAVORITE",
  SET_FAVORITES_COUNT: "SET_FAVORITES_COUNT",
};
